import React, { useEffect, useState } from "react";
import * as S from "./styles";
import { useTranslation } from "react-i18next";
import { API } from "shared/services";
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router";
import { createNewTag, editTagName } from "modules/app/utils/http/tags";

function TagsForm({ location }) {
  const { t } = useTranslation();
  const [newTag, setNewTag] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const params = useParams();

  async function handleSubmitCreate() {
    setIsLoading(true);

    try {
      await createNewTag(newTag);
      toast.success(t("TagsManager:createTagSuccess"));
      history.push("/app/tags");
    } catch (err) {
      toast.error(t("TagsManager:createTagError"));
    }

    setIsLoading(false);
  }

  async function handleSubmitUpdate() {
    setIsLoading(true);

    try {
      await editTagName(params.id, newTag);
      toast.success(t("TagsManager:editTagSuccess"));
      history.push("/app/tags");
    } catch (err) {
      toast.error(t("TagsManager:editTagError"));
    }

    setIsLoading(false);
  }

  useEffect(() => {
    if (params?.id) {
      setIsEditMode(true);
      setNewTag(location?.state?.currentTagName);
    }
  }, []);

  return (
    <S.Container>
      <S.Header
        style={{
          fontWeight: "bold",
          fontSize: 22,
          display: "flex",
          justifyContent: "row",
          alignItems: "center",
        }}
      >
        <S.goBackButton
          onClick={() => history.goBack()}
          className="icon-button"
        />
        {isEditMode
          ? t("TagsManager:editTagTitle")
          : t("TagsManager:addNewTagTitle")}
      </S.Header>
      <S.NewTagContent>
        <S.NewTagTitle>
          {isEditMode
            ? t("TagsManager:editTagNameTitle")
            : t("TagsManager:createNewTagTitle")}
        </S.NewTagTitle>
        <S.NewTagInput
          required
          type="text"
          placeholder={
            isEditMode ? location?.state?.currentTagName : "Insira nome"
          }
          value={newTag}
          onChange={(event) => setNewTag(event.target.value)}
        />
        {isEditMode ? (
          <S.NewTagButton onClick={handleSubmitUpdate}>
            {isLoading ? <S.Loading /> : t("TagsManager:editTagButton")}
          </S.NewTagButton>
        ) : (
          <S.NewTagButton onClick={handleSubmitCreate}>
            {isLoading ? <S.Loading /> : t("TagsManager:createNewTagButton")}
          </S.NewTagButton>
        )}
      </S.NewTagContent>
    </S.Container>
  );
}

export default TagsForm;
